import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db } from "./firebase";
import { ref, get } from "firebase/database";

export default function TicketPrintPage() {
  const { orderId, distributorId } = useParams();
  const navigate = useNavigate();
  const componentRef = useRef(null);

  const [order, setOrder] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [distributor, setDistributor] = useState({ name: "", phone: "" });

  // جلب الطلب
  useEffect(() => {
    if (!orderId || !distributorId) {
      setError("Paramètres invalides");
      setLoading(false);
      return;
    }

    const orderRef = ref(db, `distributors/${distributorId}/orders/${orderId}`);
    get(orderRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          setOrder(data);

          const productsArray = [];
          if (data.products) {
            Object.entries(data.products).forEach(([key, product]) => {
              productsArray.push({ ...product, productKey: key });
            });
          }
          setProducts(productsArray);
        } else {
          setError("Commande introuvable");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Erreur de chargement");
        setLoading(false);
      });
  }, [orderId, distributorId]);

  // جلب الموزع
  useEffect(() => {
    if (!distributorId) return;

    const userRef = ref(db, `users/${distributorId}`);
    get(userRef).then((snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        setDistributor({
          name: data.tradeName || "",
          phone: data.phone || "",
        });
      }
    });
  }, [distributorId]);

  const handlePrint = () => {
    window.print();
  };

  // حالات العرض
  if (loading)
    return <div style={{ textAlign: "center", padding: 50 }}>Chargement...</div>;

  if (error)
    return (
      <div style={{ textAlign: "center", padding: 50, color: "red" }}>{error}</div>
    );

  if (!order)
    return <div style={{ textAlign: "center", padding: 50 }}>Aucune commande</div>;

  // حساب الإجماليات
  const totalPrice = products.reduce(
    (sum, p) => sum + ((p.price || 0) * (p.quantity || 0)),
    0
  );
  const totalQuantity = products.reduce((sum, p) => sum + (p.quantity || 0), 0);

  // CSS للطباعة متكيفة مع أي حجم ورق
  const printStyles = `
    @media print {
      .no-print { display: none !important; }
      body { margin: 0; padding: 0; }
      .ticket-container {
        width: auto !important;
        max-width: 80mm;
        min-width: 50mm;
        margin: 0;
        padding: 2mm 4mm;
        font-family: monospace;
        font-size: 12px;
      }
      table { width: 100%; border-collapse: collapse; }
      th, td { padding: 2px 0; text-align: left; }
      th:last-child, td:last-child { text-align: right; }
      hr { border: 0; border-top: 1px dashed #000; margin: 4px 0; }
    }
  `;

  return (
    <div>
      {/* Toolbar شاشة */}
      <div
        className="no-print"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          padding: 12,
          background: "white",
          borderBottom: "1px solid #ccc",
          display: "flex",
          gap: 10,
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <button onClick={() => navigate(-1)} style={{ padding: "8px 16px" }}>
          ← Retour
        </button>
        <button
          onClick={handlePrint}
          style={{
            padding: "8px 16px",
            background: "#2563eb",
            color: "white",
            border: "none",
            borderRadius: 4,
          }}
        >
          🖨️ Imprimer
        </button>
        <h3 style={{ margin: 0, marginLeft: 10 }}>Ticket</h3>
      </div>

      {/* إدراج ستايل الطباعة */}
      <style>{printStyles}</style>

      {/* محتوى التذكرة */}
      <div ref={componentRef} className="ticket-container">
        <div style={{ textAlign: "center", marginBottom: 5 }}>
          <h2 style={{ margin: 0 }}>{distributor.name || "DISTRIBUTEUR"}</h2>
          <div>{new Date().toLocaleString("fr-FR")}</div>
        </div>

        <hr />

        <div>
          <p><strong>N°:</strong> #{order.orderNumber || "N/A"}</p>
          <p>
            <strong>Date:</strong>{" "}
            {order.createdAt ? new Date(order.createdAt).toLocaleString("fr-FR") : "N/A"}
          </p>
          <p>
            <strong>Client:</strong> {order.tradeName || order.nameClientAdd || "N/A"}
          </p>
        </div>

        <hr />

        <table>
          <thead>
            <tr>
              <th>Article</th>
              <th>Qté</th>
              <th>Prix</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p, idx) => (
              <tr key={idx}>
                <td>{p.name ? p.name.substring(0, 15) : "Produit"}</td>
                <td style={{ textAlign: "center" }}>{p.quantity || 0}</td>
                <td>{p.price || 0} DA</td>
              </tr>
            ))}
          </tbody>
        </table>

        <hr />

        <div>
          <p><strong>Total Qté:</strong> {totalQuantity}</p>
          <p><strong>Total:</strong> {totalPrice} DA</p>
        </div>

        <hr />

        <div style={{ textAlign: "center" }}>
          <p>Merci de votre confiance!</p>
          <p style={{ fontSize: "10px" }}>Komondi</p>
        </div>
      </div>
    </div>
  );
}